import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  LocationTargetSetting,
  isLocationValid,
} from '@bingads-webui-campaign/hotel-common-targets';

const LocationTargetSettingWithCustomValidation = ({
  validationProps, updateValidation, skipValidation, allowBidAdjustment, dealInfo, ...restProps
}) => {
  const { data: locationTargets } = validationProps;
  const i18n = useContext(I18nContext);
  const activity = useContext(ActivityContext);

  const onChange = useCallback((newData) => {
    let errors = [];

    if (!skipValidation) {
      errors = isLocationValid(newData) ? [] : [i18n.getString(_TL_('Location target has validation errors'))];
    }

    const isForDeal = _.get(dealInfo, 'isForDeal', false);
    if (isForDeal) {
      errors = isLocationValid(newData, 'placeholder', dealInfo) ? [] : [i18n.getString(_TL_('Location target has validation errors.'))];
    }

    updateValidation(errors, { locationTargets: newData });

    if (activity) {
      // signal activity to parent
      activity.signal(`onLocationTargettingChange - ${JSON.stringify(newData)}`);
    }
  }, [skipValidation, updateValidation, activity, i18n, dealInfo]);

  return (locationTargets ?
    <LocationTargetSetting
      allowBidAdjustment={allowBidAdjustment}
      data={locationTargets}
      setData={onChange}
      dealInfo={dealInfo}
      {...restProps}
    /> : <div />
  );
};

LocationTargetSettingWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      locationTargets: PropTypes.shape({}),
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  skipValidation: PropTypes.bool,
  allowBidAdjustment: PropTypes.bool,
  dealInfo: PropTypes.shape({
    isForDeal: PropTypes.bool,
    dealCountryCode: PropTypes.string,
    dealSupportedLocationType: PropTypes.arrayOf(PropTypes.string),
  }),
};

LocationTargetSettingWithCustomValidation.defaultProps = {
  skipValidation: true,
  allowBidAdjustment: false,
  dealInfo: {},
};

export const ValidatedLocationTargetSetting = withCustomValidation(LocationTargetSettingWithCustomValidation);
